import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationStatusTag',
  props: {
    status: {},
    effect: {},
    size: {}
  },
  setup(__props: any) {

const props = __props;

// 获取标签类型
const getTagType = computed(() => {
  if (!props.status) return 'info';
  
  switch (props.status) {
    case 'submitted':
      return 'primary';
    case 'in_review':
      return 'warning';
    case 'accepted':
      return 'success';
    case 'rejected':
      return 'danger';
    case 'withdrawn':
      return 'info';
    case 'not_started':
    default:
      return 'info';
  }
});

// 获取状态文本
const getStatusText = computed(() => {
  if (!props.status) return '未设置';
  
  const statusMap: Record<string, string> = {
    'not_started': '未开始',
    'draft': '草稿',
    'submitted': '已提交',
    'in_review': '审核中',
    'accepted': '已录用',
    'rejected': '已拒绝',
    'withdrawn': '已撤回',
    'pending': '待处理'
  };
  
  return statusMap[props.status] || props.status;
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(_component_el_tag, {
    type: getTagType.value,
    effect: _ctx.effect || 'light',
    size: _ctx.size || 'default',
    class: "application-status-tag"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(getStatusText.value), 1)
    ]),
    _: 1
  }, 8, ["type", "effect", "size"]))
}
}

})